var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5254 22C18.0482 22 22.5254 17.5228 22.5254 12C22.5254 6.47715 18.0482 2 12.5254 2C7.00254 2 2.52539 6.47715 2.52539 12C2.52539 17.5228 7.00254 22 12.5254 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04621 11.8918C9.96045 10.6262 11.9005 9.78524 12.8747 9.37725C15.6474 8.21988 16.2302 8.02005 16.6049 8.01172C16.6882 8.01172 16.8714 8.02837 16.9963 8.12829C17.0962 8.21155 17.1211 8.3198 17.1378 8.40306C17.1545 8.48632 17.1711 8.66118 17.1545 8.7944C17.0046 10.3764 16.3551 14.2149 16.0221 15.9801C15.8805 16.7295 15.6057 16.9792 15.3393 17.0042C14.7564 17.0542 14.3152 16.6212 13.7573 16.2549C12.8747 15.6803 12.3834 15.3223 11.5258 14.7561C10.535 14.1066 11.1761 13.7486 11.7423 13.1658C11.8922 13.0159 14.4484 10.6845 14.4983 10.4763C14.5067 10.4514 14.5067 10.3514 14.4484 10.3015C14.3901 10.2515 14.3068 10.2682 14.2402 10.2848C14.1486 10.3015 12.7498 11.234 10.0271 13.0742C9.62739 13.3489 9.26936 13.4822 8.94463 13.4738C8.58659 13.4655 7.90383 13.274 7.38759 13.1075C6.76311 12.9076 6.26353 12.7994 6.30516 12.4497C6.33014 12.2665 6.57993 12.0833 7.04621 11.8918Z",
    fill: "#333235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.255854a97629cf2d2ccf766b00701f96.svg";
export { ForwardRef as ReactComponent };